import React from "react";
import { Heading } from "@americanexpress/dls-react";
import "./ProductandRolesStyle.css";
import { useTranslation } from "react-i18next";
import Header from "../Header/Header";

const ProductAndRoles = () => {
  const { t, i18n } = useTranslation("common");
  i18n.changeLanguage(localStorage.getItem("lang"));

  const iec = <p>{t("country.iec")}</p>;

  return (
    <>
      <Header showlang={false} />
      <section id="product-page" className="mainBodyStatic">
        <div className="ProductPage">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <Heading
                  level={1}
                  headingStyle={"heading5"}
                  className="margin-1-b"
                >
                  {t("products_new.title")}
                </Heading>

                <div className="products">
                  <table className="table-hover">
                    <thead>
                      <tr>
                        <th>{t("products_new.functionname")}</th>
                        <th>{t("products_new.countries")}</th>
                        <th>{t("products_new.description")}</th>
                        <th>{t("products_new.roles")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{t("products_new.functname1")}</td>
                        {localStorage.getItem("lang") === "jap" ? (
                          <td className="country">
                            <p>{t("country.japan")}</p>
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            {iec}
                          </td>
                        ) : (
                          <td className="country">
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.japan")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.unitedKingdom")}</p>
                            {iec}
                          </td>
                        )}

                        <td>
                          <p>{t("products_new.opm-description")}</p>
                          <br />
                          <ul style={{ listStyleType: "disc" }}>
                            <li style={{ listStyleType: "disc" }}>
                              {t("products_new.opm-list1")}
                            </li>
                            <li>{t("products_new.opm-list2")}</li>
                            <li>{t("products_new.opm-list3")}</li>
                            <li>{t("products_new.opm-list4")}</li>
                            <li>{t("products_new.opm-list5")}</li>
                            {localStorage.getItem("lang") === "en" ? (
                              <>
                                <li>{t("products_new.opm-list6")}</li>
                                <li>{t("products_new.opm-list7")}</li>
                                <li>{t("products_new.opm-list8")}</li>
                              </>
                            ) : null}
                          </ul>
                        </td>
                        <td>
                          <b>{t("products_new.role-pa")}</b>
                          {t("products_new.roledefault")}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("products_new.functname2")}</td>

                        {localStorage.getItem("lang") === "jap" ? (
                          <td className="country">
                            <p>{t("country.japan")}</p>
                            <p>{t("country.australia")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            {iec}
                          </td>
                        ) : (
                          <td className="country">
                            <p>{t("country.australia")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.japan")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.unitedKingdom")}</p>
                            {iec}
                          </td>
                        )}
                        <td>
                          <p> {t("products_new.oca-description")}</p>
                          <br />
                          <ul>
                            <li>{t("products_new.oca-list1")}</li>
                            <li>{t("products_new.oca-list2")}</li>
                            <li>{t("products_new.oca-list3")}</li>
                            <li>{t("products_new.oca-list4")}</li>
                            <li>{t("products_new.oca-list5")}</li>
                            <li>{t("products_new.oca-list6")}</li>
                          </ul>
                        </td>
                        <td>
                          <div>
                            <b>{t("products_new.role-pa")}</b>
                            {t("products_new.role-desc-pa")}
                          </div>
                          <br />
                          <div>
                            <b>{t("products_new.role-as")}</b>
                            {t("products_new.role-desc-as")}
                          </div>
                          <br />
                          <div>
                            <b>
                              {t("products_new.*")}
                              {t("country.singapore")}
                            </b>
                            {t("products_new.role-sg")}
                          </div>
                        </td>
                      </tr>
                      {localStorage.getItem("lang") === "en" && (
                        <tr>
                          <td>{t("products_new.functname13")}</td>
                          <td className="country">
                            <p>{t("country.norway")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.unitedKingdom")}</p>
                            {iec}
                          </td>
                          <td>
                            <p>{t("products_new.cdsd-list1")}</p>
                            <br />
                          </td>
                          <td>
                            <b>{t("products_new.role-pa")}</b>
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td>{t("products_new.functname3")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                          <p>{t("country.unitedKingdom")}</p>
                        </td>
                        <td>
                          <p>{t("products_new.cop-description")}</p>
                          <br />
                          <p>
                            <ul>
                              <li>{t("products_new.cop-list1")}</li>
                              <li>{t("products_new.cop-list2")}</li>
                              <li>{t("products_new.cop-list3")}</li>
                              <li>{t("products_new.cop-list4")}</li>
                            </ul>
                          </p>
                          <br />
                          <p>{t("products_new.cop-description2")}</p>
                        </td>
                        <td>
                          {localStorage.getItem("lang") === "en" ? (
                            <>
                              <b>{t("products_new.role-pa")}</b>
                              {t("products_new.roledefault")}
                            </>
                          ) : (
                            <>
                              <b>{t("products_new.role-pa-Jp")}</b>
                              {t("products_new.role-default-Jp")}
                            </>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname4")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                          <p>{t("country.india")}</p>
                          <p>{t("country.singapore")}</p>
                          <p>{t("country.unitedKingdom")}</p>
                        </td>
                        <td>
                          <p> {t("products_new.cmr-description")}</p>
                          <br />
                          <ul>
                            <li>{t("products_new.cmr-list1")}</li>
                            <li>{t("products_new.cmr-list2")}</li>
                            <li>{t("products_new.cmr-list3")}</li>
                            <li>{t("products_new.cmr-list4")}</li>
                          </ul>
                        </td>
                        <td>
                          <div>
                            {localStorage.getItem("lang") === "en" ? (
                              <b>CMR {t("products_new.role-pa")}</b>
                            ) : (
                              <b>{t("products_new.role-cmr-pa")}</b>
                            )}
                            {t("products_new.role-desc-cmr-pa")}
                          </div>
                          <br />
                          <div>
                            <b>{t("products_new.role-apa")}</b>{" "}
                            {t("products_new.role-desc-apa")}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname5")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                          <p>{t("country.hongkong")}</p>
                          <p>{t("country.india")}</p>
                          <p>{t("country.newzealand")}</p>
                          <p>{t("country.norway")}</p>
                          <p>{t("country.singapore")}</p>
                          <p>{t("country.sweden")}</p>
                          <p>{t("country.unitedKingdom")}</p>
                          {iec}
                        </td>
                        <td>{t("products_new.bta-c-description")}</td>
                        <td>
                          <b>{t("products_new.role-pa")}</b>
                          {t("products_new.roledefault")}
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname6")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                          <p>{t("country.hongkong")}</p>
                          <p>{t("country.india")}</p>
                          <p>{t("country.newzealand")}</p>
                          <p>{t("country.singapore")}</p>
                        </td>
                        <td>{t("products_new.bta-r-description")}</td>
                        <td>
                          <b>{t("products_new.role-pa")}</b>
                          {t("products_new.roledefault")}
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname7")}</td>
                        {localStorage.getItem("lang") === "jap" ? (
                          <td className="country">
                            <p>{t("country.japan")}</p>
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                            {iec}
                          </td>
                        ) : (
                          <td className="country">
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.japan")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                            <p>{t("country.unitedKingdom")}</p>
                            {iec}
                          </td>
                        )}
                        <td>{t("products_new.work-std-description")}</td>
                        <td>
                          <b>{t("products_new.role-pa")}</b>
                          {t("products_new.roledefault")}
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname8")}</td>
                        {localStorage.getItem("lang") === "jap" ? (
                          <td className="country">
                            <p>{t("country.japan")}</p>
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                            {iec}
                          </td>
                        ) : (
                          <td className="country">
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.japan")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.norway")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.sweden")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                            <p>{t("country.unitedKingdom")}</p>
                            {iec}
                          </td>
                        )}
                        <td>
                          <p>{t("products_new.work-cust-description")}</p>
                          <br />
                          {localStorage.getItem("lang") === "en" ? null : (
                            <p>{t("products_new.work-cust-description-2")}</p>
                          )}
                        </td>

                        <td>
                          <b>{t("products_new.role-pa")}</b>{" "}
                          {t("products_new.roledefault")}
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname9")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                          <p>{t("country.unitedKingdom")}</p>
                        </td>
                        <td>{t("products_new.amex-pay-description")}</td>
                        <td>
                          <div>
                            <b>
                              {localStorage.getItem("lang") === "en" ? (
                                <>{t("products_new.role-pa")}</>
                              ) : (
                                <> {t("products_new.role-pa-Jp")}</>
                              )}
                              {t("products_new.partialaccess")}{" "}
                            </b>{" "}
                            {localStorage.getItem("lang") === "en" ? (
                              <p>{t("products_new.ability")}</p>
                            ) : null}
                            <p>{t("products_new.search-users")} </p>
                            <p>{t("products_new.create-request")} </p>
                            <p>{t("products_new.advsearch")} </p>
                            <p>{t("products_new.workflow-app")} </p>
                            <p>{t("products_new.file")} </p>
                            <p>{t("products_new.manage-custom-fields")}</p>
                          </div>
                          <br />
                          <div>
                            <b>
                              {localStorage.getItem("lang") === "en" ? (
                                <>{t("products_new.role-pa")}</>
                              ) : (
                                <> {t("products_new.role-pa-Jp")}</>
                              )}
                              {t("products_new.completeaccess")}{" "}
                            </b>{" "}
                            {localStorage.getItem("lang") === "en" ? (
                              <>
                                <p> {t("products_new.ability")}</p>
                              </>
                            ) : null}
                            <p>{t("products_new.search-users")} </p>
                            <p>{t("products_new.create-request")} </p>
                            <p>{t("products_new.advsearch")} </p>
                            <p>{t("products_new.workflow-setup")} </p>
                            <p>{t("products_new.workflow-app")} </p>
                            <p>{t("products_new.manage-custom-fields")}</p>
                            <p>{t("products_new.summary")} </p>
                            <p>{t("products_new.file")} </p>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname12")}</td>
                        <td className="country">
                          <p>{t("country.australia")}</p>
                        </td>
                        <td>{t("products_new.amex-go-description")}</td>
                        <td>
                          <div>
                            {localStorage.getItem("lang") === "en" ? (
                              <>
                                <b>{t("products_new.role-pa")}</b>{" "}
                                {t("products_new.roledefault")}
                              </>
                            ) : (
                              <>
                                <b>{t("products_new.role-pa-Jp")}</b>{" "}
                                {t("products_new.role-default-Jp")}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname10")}</td>
                        {localStorage.getItem("lang") === "jap" ? (
                          <td className="country">
                            <p>{t("country.japan")}</p>
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                          </td>
                        ) : (
                          <td className="country">
                            <p>{t("country.australia")}</p>
                            <p>{t("country.hongkong")}</p>
                            <p>{t("country.india")}</p>
                            <p>{t("country.japan")}</p>
                            <p>{t("country.newzealand")}</p>
                            <p>{t("country.singapore")}</p>
                            <p>{t("country.taiwan")}</p>
                            <p>{t("country.thailand")}</p>
                            <p>{t("country.gdc")}</p>
                          </td>
                        )}
                        <td>
                          <div>
                            <p>{t("products_new.reconcilation-description")}</p>
                            <br />
                            {localStorage.getItem("lang") === "jap" ? (
                              <ul>
                                <li>
                                  {t("products_new.reconcilation-description1")}
                                </li>
                                <li>
                                  {t("products_new.reconcilation-description2")}
                                </li>
                                <li>
                                  {t("products_new.reconcilation-description3")}
                                </li>
                                <li>
                                  {t("products_new.reconcilation-description4")}
                                </li>
                              </ul>
                            ) : (
                              <>
                                <p>
                                  {t("products_new.reconcilation-description1")}
                                </p>
                                <p>
                                  {t("products_new.reconcilation-description2")}
                                </p>
                                <p>
                                  {t("products_new.reconcilation-description3")}
                                </p>
                                <p>
                                  {t("products_new.reconcilation-description4")}
                                </p>
                              </>
                            )}
                          </div>
                        </td>
                        <td>
                          <div>
                            {localStorage.getItem("lang") === "en" ? (
                              <b>{t("products_new.role-pa")}</b>
                            ) : (
                              <b> {t("products_new.role-pa-Jp")}</b>
                            )}
                            <b> {t("products_new.roledefault")}</b>
                            <p>
                              <b>{t("products_new.cardmem")}</b>
                            </p>
                            <p>
                              <b>{t("products_new.cardmanager")}</b>
                            </p>
                            <p>
                              <b>{t("products_new.bcamem")}</b>
                            </p>
                            <p>
                              <b>{t("products_new.sysadmin")}</b>
                            </p>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>{t("products_new.functname11")}</td>
                        <td className="country">
                          <p>{t("country.japan")}</p>
                        </td>
                        <td>{t("products_new.consolidated-description")}</td>
                        <td>
                          <div>
                            <b>{t("products_new.role-pa")}</b>{" "}
                            {t("products_new.roledefault")}{" "}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{t("products_new.functname15")}</td>
                        <td className="country">
                          <p>{t("country.japan")}</p>
                        </td>
                        <td>{t("products_new.consolidated-description")}</td>
                        <td>
                          <div>
                            <b>{t("products_new.role-pa")}</b>{" "}
                            {t("products_new.roledefault")}{" "}
                          </div>
                        </td>
                      </tr>

                      {localStorage.getItem("lang") === "en" && (
                        <tr>
                          <td>{t("products_new.functname14")}</td>
                          <td className="country">
                            {t("country.unitedKingdom")}{" "}
                            {t("products_new.only")}
                          </td>
                          <td>
                            <p>{t("products_new.bip-list1")}</p>
                            <br />
                          </td>
                          <td>
                            <b>{t("products_new.role-pa")}</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ProductAndRoles;
